import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
export class ExtendedClientDataData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        this.userChoices = null;
        if (this.dataExists(this.data)) {
            const clientData = this.data.getDataObject("clientData");
            if (this.dataExists(clientData)) {
                if (clientData.containsKey("choices")) {
                    this.userChoices = clientData.getNumberArray("choices");
                }
            }
        }
    }
    getUserChoices() {
        return this.userChoices;
    }
}
//# sourceMappingURL=ExtendedClientDataData.js.map